import createIcon from '../../createIcon';

/**
 * @component @name Repartition
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41IDIxLjVIMjEuNVYxNS41SDMuNVYyMS41Wk0xMC44MyAxOS41VjE3LjVIMTQuMTZWMTkuNUgxMC44M1pNMTkuNSAxOS41SDE2LjE3VjE3LjVIMTkuNVYxOS41Wk01LjUgMTcuNUg4LjgzVjE5LjVINS41VjE3LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNi41IDEwLjVMNy45MiA5LjA4TDYuMzMgNy41SDE3LjVDMTguNiA3LjUgMTkuNSA4LjQgMTkuNSA5LjVDMTkuNSAxMC42IDE4LjYgMTEuNSAxNy41IDExLjVIMy41VjEzLjVIMTcuNUMxOS43MSAxMy41IDIxLjUgMTEuNzEgMjEuNSA5LjVDMjEuNSA3LjI5IDE5LjcxIDUuNSAxNy41IDUuNUg2LjMzTDcuOTIgMy45MUw2LjUgMi41TDIuNSA2LjVMNi41IDEwLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Repartition = createIcon('Repartition', [
  [
    'path',
    {
      d: 'M3.5 21.5H21.5V15.5H3.5V21.5ZM10.83 19.5V17.5H14.16V19.5H10.83ZM19.5 19.5H16.17V17.5H19.5V19.5ZM5.5 17.5H8.83V19.5H5.5V17.5Z',
      key: 'qq3u6',
    },
  ],
  [
    'path',
    {
      d: 'M6.5 10.5L7.92 9.08L6.33 7.5H17.5C18.6 7.5 19.5 8.4 19.5 9.5C19.5 10.6 18.6 11.5 17.5 11.5H3.5V13.5H17.5C19.71 13.5 21.5 11.71 21.5 9.5C21.5 7.29 19.71 5.5 17.5 5.5H6.33L7.92 3.91L6.5 2.5L2.5 6.5L6.5 10.5Z',
      key: 'qinpn1',
    },
  ],
]);

export default Repartition;
